import { UserRole } from "../types/types";
import { defaultPaths } from "./data";

export const CoachUser: UserRole = {
  value: 2,
  paths: ["/coach-availability", "/coach-plans", ...defaultPaths],
};

export const AdminUser: UserRole = {
  value: 1,
  paths: ["/order-description", "/orders", ...defaultPaths],
};

export const MOBILE_SCREEN_WIDTH = 768;
export const TAB_SCREEN_WIDTH = 1246;
export const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const REQUEST_PLAYER_DATES_LIST_COUNT = 6;
